import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.iterator.js";
import * as echarts from "echarts";
import { payItemLineCount } from "@/api/data";
export default {
  name: "SelectPayItemLine",
  props: {
    sendTimeArrData: {
      type: Array
    },
    serverID: {
      type: Array
    },
    goodId: {
      type: Array
    }
  },
  watch: {
    // sendTimeArrData(newVal) {
    //     if (newVal) {
    //         this.initTime();
    //     }
    // },
    // serverID(newVal) {
    //     if (newVal) {
    //         this.initTime();
    //     }
    // },
  },
  data: function data() {
    return {
      //重新赋值
      sendTimeArr: [],
      //当前时间的数组
      RoleArrTime: [],
      //当前数量的数组
      RoleArrNum: [],
      //拿选中的俩个日期的前一天
      sendBeforeTimeArr: [],
      TimeTitle: [],
      startValue: "",
      endValue: "",
      dateArr: [],
      seriesArr: [],
      legendDataArr: [],
      payItemLineCountNow: "",
      payItemArrTime: [],
      payItemArrNum: []
    };
  },
  methods: {
    initTime: function initTime() {
      if (this.sendTimeArrData) {
        this.sendTimeArr = this.sendTimeArrData; //['2021-10-12', '2021-10-13']
        this.startValue = this.sendTimeArrData[0];
        this.endValue = this.sendTimeArrData[1];
        this.getDateTime();
      } else {
        this.sendTimeArr = [this.getNextDate(), this.getNowtDate()];
        this.sendBeforeTimeArr = [this.getNextDate(this.sendTimeArr[0]), this.getNextDate(this.sendTimeArr[1])];
        this.startValue = this.getNextDate();
        this.endValue = this.getNowtDate();
        this.getDateTime();
      }
    },
    defaultTime: function defaultTime() {
      return [this.getNextDate(), this.getNowtDate()];
    },
    getNextDate: function getNextDate(data) {
      var dd = "";
      if (data) {
        dd = new Date(data); //Thu Oct 14 2021 16:28:17 GMT+0800 (中国标准时间)
      } else {
        dd = new Date();
      }
      dd.setDate(dd.getDate() - 1);
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      return y + "-" + m + "-" + d;
    },
    getNowtDate: function getNowtDate() {
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    },
    getDateTime: function getDateTime() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getPayItemArr();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getPayItemArr: function getPayItemArr() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var idArr, k, seriesInfo;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.payItemLineCountNow = "";
              _this2.payItemArrTime = [];
              _this2.payItemArrNum = [];
              _context2.next = 5;
              return payItemLineCount({
                sdate: _this2.sendTimeArr[0],
                edate: _this2.sendTimeArr[1],
                good_id: _this2.goodId,
                server_id: _this2.serverID
              });
            case 5:
              _this2.payItemLineCountNow = _context2.sent;
              _this2.dateArr = _this2.payItemLineCountNow.data.date_arr;
              _this2.seriesArr = [];
              _this2.legendDataArr = [];
              idArr = [];
              for (k = 0; k < _this2.payItemLineCountNow.data.name_arr.length; k++) {
                seriesInfo = {
                  name: _this2.payItemLineCountNow.data.name_arr[k],
                  type: "line",
                  data: _this2.payItemLineCountNow.data.data_arr[k]
                };
                _this2.seriesArr.push(seriesInfo);
                _this2.legendDataArr.push(_this2.payItemLineCountNow.data.name_arr[k]);
                idArr.push(_this2.payItemLineCountNow.data.id_arr[k]);
              }
              if (_this2.goodId.length == 0) {
                _this2.$emit('my-event', idArr);
              }
              _this2.initCharts();
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    //x轴去重
    dupRepeat: function dupRepeat(arr) {
      if (!Array.isArray(arr)) {
        return;
      }
      return Array.from(new Set(arr));
    },
    initCharts: function initCharts() {
      var chartDom = document.getElementById("mainOne");
      var myChartOne = echarts.init(chartDom);
      // 绘制图表
      myChartOne.setOption({
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.legendDataArr
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          name: "日期",
          data: this.dateArr
        },
        yAxis: {
          type: "value",
          name: "完成付费数"
        },
        series: this.seriesArr
      }, true);
    }
  },
  mounted: function mounted() {
    this.initTime();
  }
};